export default __webpack_public_path__ + "static/media/close-gray.616641f7.svg";